import {memo} from 'react'

import {useBuildId, useBuildTypeId} from '../../../../hooks/routes'
import Loader from '../../../common/Loader/Loader'
import SequenceLoader from '../../../common/SequenceLoader/SequenceLoader'

import ChangesAdvancedView from './ChangesAdvancedView/ChangesAdvancedView'
import ChangesRevisions from './ChangesRevisions/ChangesRevisions'

function BuildChangesTab() {
  const buildId = useBuildId()
  const buildTypeId = useBuildTypeId()
  return buildId != null && buildTypeId != null ? (
    <SequenceLoader loader={<Loader />}>
      <ChangesRevisions seqKey="Revisions" buildId={buildId} />
      <ChangesAdvancedView seqKey="Changes" buildId={buildId} buildTypeId={buildTypeId} />
    </SequenceLoader>
  ) : null
}

export default memo<{}>(BuildChangesTab)
